import { create } from 'zustand';
import { axiosInstance } from '@/utils/lib/axios';
import { errorHandler } from '@/utils/functions/errorHandler';
import { env } from '@/utils/constants/env';
import useTenantState from './tenant.state';
import useOrgChartState from './organization.state';

interface CompanyProfileCompletionState {
  overallCompletion: number;
  sections: Record<string, number>;
  isLoading: boolean;
  error: unknown;

  fetchCompletion: (organizationId?: number) => Promise<void>;
}

const useCompanyProfileCompletionState = create<CompanyProfileCompletionState>(set => ({
  overallCompletion: 0,
  sections: {},
  isLoading: false,
  error: null,

  fetchCompletion: async (organizationId?: number) => {
    set({ isLoading: true, error: null });

    try {
      const tenantId = useTenantState.getState().currentTenant?.id;

      const orgId =
        organizationId ??
        useOrgChartState.getState().selectedOrganizationId;

      if (!tenantId) {
        set({ isLoading: false });
        return;
      }

      let url = `${env.apiTasklistBaseUrl}/api/v1/compro/company-profile/${tenantId}/completion`;

      if (orgId) {
        url += `?organization_id=${orgId}`;
      }

      const { data } = await axiosInstance.get(url);

      set({
        overallCompletion: data?.data?.overall_completion ?? 0,
        sections: data?.data?.sections ?? {},
        isLoading: false,
      });
    } catch (error) {
      errorHandler(error);
      set({ error, isLoading: false });
    }
  }
}));

export default useCompanyProfileCompletionState;
